var map = {
	"./fortuneIcon.svg": 684,
	"./fortuneIconL.svg": 685,
	"./helpdeskIcon.svg": 686,
	"./helpdeskIconL.svg": 687,
	"./homeIcon.svg": 688,
	"./homeIconLarge.svg": 689,
	"./jackpotIcon.svg": 690,
	"./logo.svg": 691,
	"./logoSmall.svg": 692,
	"./loyaltyIcon.svg": 693,
	"./mobileAppIcon.svg": 694,
	"./profileIcon.svg": 695,
	"./questIcon.svg": 696,
	"./questsIcon.svg": 697,
	"./rewardLineupIcon.svg": 698,
	"./searchIcon.svg": 699,
	"./searchIconLarge.svg": 700,
	"./signOutIcon.svg": 701,
	"./star.svg": 702,
	"./tournamentIcon.svg": 703,
	"./tournamentLargeIcon.svg": 704,
	"./vipIcon.svg": 705,
	"./wheelIcon.svg": 706,
	"./wheelIconL.svg": 707,
	"./wheelIconMobile.svg": 708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 683;